import { getExamEntry } from '@/api/dsa'
import { getUserId } from '@/utils/store'

/**
 * Load exam schedule for a DSA application (for View exam modal).
 * @returns {Promise<object|null>} exam entry payload or null
 */
export async function loadExamSchedule(vm, applicationId) {
  const student_id = getUserId()
  if (!applicationId || !student_id) {
    vm.$emit && vm.$emit('toast', 'Missing exam context')
    return null
  }
  try {
    const res = await getExamEntry(applicationId, student_id)
    if (!(res.data && res.data.code === 0)) {
      const msg = (res.data && res.data.msg) || 'Exam not available'
      if (vm.$emit) vm.$emit('toast', msg)
      else if (vm.$message) vm.$message.warning(msg)
      return null
    }
    return res.data.data || {}
  } catch (e) {
    if (vm.$emit) vm.$emit('toast', 'Failed to load exam schedule')
    return null
  }
}

/** @deprecated Prefer View exam modal + learningfirst exam system. */
export async function enterExam(vm, applicationId) {
  return loadExamSchedule(vm, applicationId)
}
